module.exports = __webpack_public_path__ + "img/location.28e0a646.svg";